import { GridEventListener } from "@mui/x-data-grid-premium";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { MutableRefObject, useEffect } from "react";

export interface AutosizeTreeDataGroupingColumnProps {
  apiRef: MutableRefObject<GridApiPremium>;
  autosizeTreeDataGroupingColumns?: boolean;
}

const useAutosizeTreeDataGroupingColumns = (props: AutosizeTreeDataGroupingColumnProps) => {
  const { apiRef } = props;

  // We need to maintain the expansion state of the tree nodes else when we update the data the tree nodes will collapse
  // TODO: We should compute the expansion state from the rows data prior to updating the rows data
  useEffect(() => {
    const handleRowExpansionChange: GridEventListener<"rowExpansionChange"> = (params: any) => {
      if (props.autosizeTreeDataGroupingColumns && apiRef.current?.getRowsCount() > 0) {
        console.log("useAutosizeTreeDataGroupingColumns");
        console.log("rowExpansionChange: ", params);

        if (params.childrenExpanded || (params.expandLevel || 0) === 0) {
          setTimeout(() => {
            apiRef.current?.autosizeColumns({
              includeOutliers: true,
              includeHeaders: true,
              expand: true
            });
          }, 0);
        }
      }
    };

    return apiRef.current?.subscribeEvent?.("rowExpansionChange", handleRowExpansionChange);
  }, [apiRef.current?.subscribeEvent, props.autosizeTreeDataGroupingColumns]);
};

export default useAutosizeTreeDataGroupingColumns;
